import PropTypes from 'prop-types';

export const windowShape = PropTypes.shape({
  start: PropTypes.object.isRequired,
  end: PropTypes.object.isRequired,
});
